import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {debounceTime, distinctUntilChanged, filter, switchMap, tap, map} from 'rxjs/operators';
import {merge, Observable, Subject} from 'rxjs';
import {NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {DataService} from '../../../@core/utils';

@Component({
  selector: 'app-type-ahead',
  templateUrl: './type-ahead.component.html',
  styleUrls: ['./type-ahead.component.scss']
})
export class TypeAheadComponent {

  searching: boolean;
  searchFailed: boolean = true;
  spinner: boolean = false;
  dataLoading: boolean = false;
  data$: Promise<any[]>;
  dataInput$ = new Subject<string>();
  @Input() multiple: boolean = false;
  @Input() model: any;
  @Input() disabled: any;
  @Input() filters: any;
  @Input() required = true;
  @Input() basePath = 'auth';
  @Input() placeholder: string = 'Search here';
  @Input() url: string;
  @Input() text: string = '';
  @Input() selectedItems = [];
  @Input() value: string;
  @Input() notifySearchFail: boolean = false;
  @Input() displayNames: string[] = [];
  @Output() searchTerm: EventEmitter<string> = new EventEmitter();
  @Output() send: EventEmitter<any> = new EventEmitter();
  @Output() failed: EventEmitter<string> = new EventEmitter();
  @Output() cleared: EventEmitter<string> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('instance', {static: true}) instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  results: any[] = [];

  constructor(private http: DataService) {
  }



  async searchApi(event) {
    try {
      const query = {};
      if (parseInt(event, 10)) {
        query['__mobile_number__contains'] = event;
      } else {
        query['__name__contains'] = event;
      }

      for (const i in this.filters) {
        if (this.filters.hasOwnProperty(i)) {
          query[i] = this.filters[i];
        }
      }

      const res = await this.http.query(query, this.url, this.basePath);
      if (!res.hasOwnProperty('data')) {
        this.searchFailed = true;
        this.results = [];
        return [];
      } else {
        this.searchFailed = false;
        this.results = res.data;
        return res.data;
      }
    } catch (e) {
      this.searchFailed = true;
      this.results = [];
      return [];
    }
  }

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(
      debounceTime(300),
      distinctUntilChanged());

    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      tap(() => this.searching = true),
      switchMap(async (term) => {
          try {
            const query = {};
            if (parseInt(term, 10)) {
              query['__phone__contains'] = term;
            } else {
              query['__name__contains'] = term;
            }

            for (const i in this.filters) {
              if (this.filters.hasOwnProperty(i)) {
                query[i] = this.filters[i];
              }
            }

            const res = await this.http.query(query, this.url);
            this.searchTerm.emit(term);
            if (!res.hasOwnProperty('data')) {
              this.searchFailed = true;
              return [];
            } else {
              this.searchFailed = false;
              return res.data;
            }
          } catch (e) {
            this.searchTerm.emit(term);
            this.searchFailed = true;
            return [];
          }
        },
      ),
      tap(() => this.searching = false),
    );
  }


  emitSelected(event: any | string) {
    if (typeof event === typeof 'str') {
      return;
    }
    this.text = event.name;
    this.send.emit(event);
    this.searchFailed = true;
  }

  // @ts-ignore
  formatter = (x: { name: string }) => {
    if (!x.name) {
      return;
    }
    if (this.displayNames && this.displayNames.length) {
      return this.displayNames.map(d => x[d]).join(',');
    }
    return x.name;
  }

  resultFormatter = (x: { name: string, phone: string }) => {
    if (!x || (!x.name && !this.displayNames)) {
      return;
    }
    if (this.displayNames && this.displayNames.length) {
      return this.displayNames.map(d => x[d]).join(', ');
    }
    if (x.phone) {
      return x.name + ' - ' + x.phone;
    }
    return x.name;
  }

  async loadPeople() {
    try {
      this.data$ = this.searchApi(undefined);
    } catch (e) {
    }
    this.dataInput$.pipe(
      distinctUntilChanged(),
      debounceTime(700),
      tap(() => {
        this.dataLoading = true;
      }),
      map(async term => {
        this.spinner = true;
        return this.searchApi(term);
      })).subscribe(async res => {
      this.data$ = res;
      await res;
      this.spinner = false;
      this.dataLoading = false;
    }, () => {
      this.spinner = false;
      this.dataLoading = false;
    });
  }

}
